import { setSymbols } from '@type.engineering/type-engineer'
import { AbstractElemental, AbstractView } from '../../types/lux'
import Classified from './Classified'
import { createElement } from './lib'
import Painter from './Painter'
import Proper from './Proper'

export default AbstractView

/** @constructor @extends {AbstractView} @suppress {checkTypes} */ function _AbstractView() {}
AbstractView.__implement(Proper, Painter, Classified, AbstractElemental,
  _AbstractView.prototype = /** @type {!AbstractView} */ ({
    initialiser({props,classes}) {
      const{superProper,superClassified}=this
      superProper.initialiser({props})
      superClassified.initialiser({classes})
      return this
    },
  }),
)

/** @type {guest.maurice.attach} */
export function attach(Constructor, el, {
  props, classes, symbols,
} = {}, allSymbols = null) {
  const ell=/** @type {!AbstractView<!guest.maurice.Properties>} */(createElement(Constructor, el))

  if(allSymbols&&symbols)setSymbols(ell,symbols,allSymbols)

  const{asIInitialiser:{initialiser},asIEngineer:{__$constructor}}=ell
  initialiser({props,classes})
  __$constructor() // start the view

  return ell
}